import React from "react";

export default function MasterSpinner({ size = 40, className = "" }) {
	const px = typeof size === "number" ? `${size}px` : size;
	return (
		<div
			className={`master-spinner ${className}`.trim()}
			style={{ width: px, height: px }}
			role="status"
			aria-label="Carregando"
		/>
	);
}
